import { CLAW_DEFAULT_AI_MODEL } from '../../constants/clawDefaults.js';

/** Default LLM id for Studio V2 flow/app AI panels (local Ollama via CLAW defaults). */
export const STUDIO_V2_DEFAULT_AI_MODEL = CLAW_DEFAULT_AI_MODEL;
